import { sendDatadogRumError } from 'utils/analytics/datadogRum';
import zendeskGateway from 'services/help-center/zendeskBackendGateway';

const fetchZDUserId = async (memberUUID: string) => {
    try {
        const responseData = await zendeskGateway.get(`/users/search.json`, {
            params: {
                external_id: memberUUID,
            },
        });
        const data = responseData?.data;
        if (data && !Array.isArray(data.users)) {
            throw new Error('Zendesk user search response has no users array');
        }
        return data?.users?.[0];
    } catch (error) {
        sendDatadogRumError('fetchZDUserId', error, { source: 'fetchZDUserId', memberUUID });
        throw new Error('Failed to fetch ZD user id. Please try again later.');
    }
};

export default fetchZDUserId;
